import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { OneWayInServiceDto } from 'src/api/v2';

const getInitialActorReferMessageHtml = (
  fromActorName: string | undefined,
  opportunityTitle: string | undefined,
  handlersName: string | undefined,
  selectedServices: OneWayInServiceDto[],
) =>
  renderToStaticMarkup(
    <div>
      <p>
        Dere har mottatt ny henvisning fra aktør {fromActorName}. Tittel på henvendelsen:{' '}
        <u>{opportunityTitle}</u>. Gå til flerbedriftsportal.no for å følge opp kunden/henvendelsen.
      </p>
      <p>
        <br />
      </p>
      {selectedServices.length > 0 && (
        <>
          <p>Vi vil gjerne anbefale kunden følgende tjenester hos dere:</p>
          <p>
            <br />
          </p>
          <p>
            {selectedServices.map((service, index) => (
              <React.Fragment key={service.id}>
                <b>{service.name}</b>
                {index < selectedServices.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
          <p>
            <br />
          </p>
        </>
      )}
      <p>Med vennlig hilsen</p>
      <b>{handlersName}</b>
      <p>{fromActorName}</p>
    </div>,
  );

export default getInitialActorReferMessageHtml;
